import { isset } from 'helpers/string-isset'
import { Validation } from './usecases/validation'

export class RequiredValidation implements Validation {
  validate(param: string | null | undefined | []): string | null {
    if (!isset(param)) return 'This field is required'
    return null
  }
}
